import { useState, useEffect, useMemo, useCallback } from 'react';
import { contabilidadApi } from '../../services/api';
import { EntregasParciales, RegistrarPagos, ServicioAgendado } from '../../objetos/objeto_servicio';
import { useLoading } from '../../utils/LoadingProvider';
import { toast } from 'react-toastify';
import { Cliente } from '../../objetos/objeto_cliente';
import { getSocket } from '../../services/socket';
import { useConfiguracion } from '../../metodos/ConfiguracionContext';
import { useRetornoAsesor } from '../../config/unificacion';
import { toYYYYMMDD } from '../../utils/utils';

export const useContabilidadModel = () => {
    const [servicio, setServicio] = useState();
    const [servicios,setServicios] = useState();
    const [serviciosPorClientes, setServiciosCliente] = useState([]);
    const [serviciosBusqueda, setserviciosBusqueda] = useState([]);

    const [loadingServicios, setLoading] = useState(true);
    const [errorServicios, setError] = useState(null);
    const {configuracion} = useConfiguracion()

    const {withLoading } = useLoading();

    const {retornoAsesor} = useRetornoAsesor();
    const cambiadopor = retornoAsesor();


    //estadisticas tutor
    const [estadisticas, setEstadisticas] = useState();
    const [loadingEstadisticas, setloadingEstadisticas] = useState(true);
    const [errorEstasdisticas, seterrorEstasdisticas] = useState(null);

    //cargar servicios de un tutor
    const cargarServicios =  async(nameTutor,isAdmin = false) =>{
        console.log("llendo a cargar serviciios",nameTutor,isAdmin);
        if(isAdmin){
            try{
                const ahora = new Date();
                const fechaInicio = new Date(ahora.getFullYear(), ahora.getMonth(), 1);
                const fechaFinal = new Date(ahora.getFullYear(), ahora.getMonth() + 1, 0);

                setLoading(true);
                const data = await contabilidadApi.obtenerServiciosAdmin(configuracion.nombreEmpresa,fechaInicio,fechaFinal);
                //console.log("servicios obtenidos",data);
                console.log("lenght de servicios",data.length)
                
                const dataConvertida = Object.values(data);
                const serviciosObj = dataConvertida.map(item => ServicioAgendado.fromJson(item));
                //console.log("tenemos servicios en objeto",serviciosObj);

                setServicios(serviciosObj);
                setError(null);
                return serviciosObj;
            }
            catch(error){
                 console.error("Error al obtener servicios:", error);
                setError(error.message || "Error al cargar los servicios");
                return null;
            }
            finally{
                setLoading(false);
            }
        }
        else{
            try{
                setLoading(true);
                const data = await contabilidadApi.obtenerserviciosTutor(nameTutor);
                console.log("servicios obtenidos",data);
                const serviciosObj = data.map(item => ServicioAgendado.fromJson(item));
                console.log("tenemos servicios en objeto",serviciosObj.length);
                setServicios(serviciosObj);
                setError(null);
                return serviciosObj;
            }
            catch(error){
                console.error("Error al obtener servicios:", error);
                setError(error.message || "Error al cargar los servicios");
                return null;
            }
            finally{
                setLoading(false);
            }       
        }
        
    }

    //update servicio
    const updateServicio = (codigo,nombreEmpresa,field,valor,type) =>{
        return withLoading(async () =>{

            try{
                let finalUpdateData = {};

                if(!field ){
                    toast.error("Este error no deberia salir");
                    return;
                }

                if(!valor){
                    toast.error("El valor no puede ser nulo");
                    return;
                }

                if(type == "field" ){
                    const datosParaValidar = { [field]: valor };
                    const servicioTemporal = new ServicioAgendado({});
                    servicioTemporal.updateFromJson(datosParaValidar);
                    const valorConvertido = servicioTemporal.getFieldValue(field);
                    
                    finalUpdateData = {
                        [field] : valorConvertido,
                    }

                }else if(type == "array"){
                    //entregas trabajo - finalUpdateData , toca sacar con el punto
                    const campoAnidado = field;
                    const [parteIzquierda, parteDerecha] = campoAnidado.split('.');
                    const datosParaValidar = { [parteDerecha]: valor.value };
                    const entregaTemporal = new EntregasParciales({});
                    entregaTemporal.updateFromJson(datosParaValidar);
                    const valorConvertido = entregaTemporal.getFieldValue(parteDerecha);

                    finalUpdateData = {
                        "field" : parteIzquierda,
                        "elementId": valor.elementId,
                        "data": {
                           [parteDerecha] : valorConvertido,
                        }
                    }

                    console.log("tenemos finaal update",finalUpdateData);

                }

                const respuesta = await contabilidadApi.updateServicio(nombreEmpresa,codigo,type,finalUpdateData,cambiadopor);
                
                if (respuesta.success) {
                    toast.success(`Exito: ${respuesta.message}`);
                } else {
                    toast.error(`Error: ${respuesta.message}`);
                }
                    
                    


            }
            catch(error){
                toast.error("Ocurrió un error a actualizar el servicio: " + (error.message || "Error desconocido"));
                return { success: false, error: error };
            }
        },'Actualizando servicio');
    }

    //add pago
    const addPago = async(pagoData, nombreEmpresa, codigo) =>{
        return withLoading(async () =>{
            //comprobador de varialbes, todo debe estar seleccionado

            try{
                //pago toMap
                let pagoDataCompleto = { ...pagoData };
                const pagoInstance = new RegistrarPagos(pagoData);
                const pagoMap = pagoInstance.toMap();
                pagoMap.archivoPago = pagoDataCompleto.archivoPago;
                
                console.log("añadir a pago",pagoMap,nombreEmpresa,codigo);

                const respuesta = await contabilidadApi.addPago(pagoMap,nombreEmpresa,codigo,cambiadopor);

                console.log("respuesta tenemos",respuesta);

                if(respuesta.success){
                    toast.success(`Exito: ${respuesta.message}`);
                    return true;
                }else{
                    toast.error(`Error: ${respuesta.message}`);
                    return false;
                }

            }
            catch(error){
                console.log("Error al registrar pago",error);
                 toast.error(`Error al registrar pago: ${error}`);
                return false;
            }
        },'Añadiendo pago...');
    }

    //delete pago
    const deletePago = async(PagoId, nombreEmpresa, codigo) =>{
        return withLoading(async () =>{
            try{

                const respuesta = await contabilidadApi.deletePago(PagoId,nombreEmpresa,codigo,cambiadopor);

                 if (respuesta.success) {
                    toast.success(`Exito: ${respuesta.message}`);
                } else {
                    toast.error(`Error: ${respuesta.message}`);
                }

            }
            catch(error){
                console.log("Error al eliminar el pago",error);
                toast.error(`Error al eliminar el pago: ${error}`);
                return false;
            }
        },'Eliminado pago');
    }

    //add Entreg parcial
    const addEntregaParcial = async(entregaData, nombreEmpresa, codigo) =>{
        return withLoading(async () =>{
            console.log("add entrega parcial",nombreEmpresa,codigo,cambiadopor);
            try{
                let entregaDataCompleto = { ...entregaData };
                const entregaInstance = new EntregasParciales(entregaDataCompleto);
                const entregaMap = entregaInstance.toMap();
                const respuesta = await contabilidadApi.addEntregaParcial(entregaMap,nombreEmpresa,codigo,cambiadopor);

                if(respuesta.success){
                    toast.success(`Exito: ${respuesta.message}`);
                    return true;
                }else{
                    toast.error(`Error: ${respuesta.message}`);
                    return false;
                }

            }
            catch(error){
                console.log("Error al registrar la entrega parcial",error);
                toast.error(`Error al registrar la entrega parcial: ${error}`);
                return false;
            }
        }),'Añdiendo entrega...';
    }

    //delete entrega parcial
    const deleteEntregaParcial = async(entregaId, nombreEmpresa, codigo) =>{
         return withLoading(async () =>{
            try{

                const respuesta = await contabilidadApi.deleteEntregaParcial(entregaId,nombreEmpresa,codigo,cambiadopor);

                 if (respuesta.success) {
                    toast.success(`Exito: ${respuesta.message}`);
                } else {
                    toast.error(`Error: ${respuesta.message}`);
                }

            }
            catch(error){
                console.log("Error al eliminar la entrega",error);
                toast.error(`Error al eliminar la entrega: ${error}`);
                return false;
            }
        },'Eliminado Entrega parcial');
    }

    //cargar un servicio en especifico por codigo
    const cargarServicioPorCodigo = async(codigo,nombreEmpresa) =>{
        try{
            setLoading(true);
            const data = await contabilidadApi.obtenerServicioPorId(nombreEmpresa,codigo);
            const servicio_obj = ServicioAgendado.fromJson(data);
            console.log("servicio cargado",servicio_obj.codigo);
            setServicio(servicio_obj);
            return servicio_obj;
        }catch(error){
            console.error("Error al obtener servicio:", error);
            setError(error.message || "Error al cargar la solicitud");
            return null;

        }finally{
           setLoading(false);
        }
    };

    //Entregar un trabajo
    const entregarTrabajoTutor = async(formData,nombreEmpresa) =>{
        return withLoading(async () =>{
            try{
                console.log("el data es",formData);

                //verificar pesos de archivos

                if (!formData.trabajos || (Array.isArray(formData.trabajos) && formData.trabajos.length === 0)) {
                    // Show error toast for missing files
                    toast.error("Debes subir al menos un archivo para entregar el trabajo");
                    return; // Return early to prevent further execution
                }

                //subir trabajo
                console.log("subiendo trabajo por",cambiadopor);
                const respuesta = await contabilidadApi.entregarTrabajoTutor(formData,servicio.codigo,nombreEmpresa,cambiadopor);

                console.log("la respuesta es ",respuesta);
                if(respuesta.success){
                    toast.success(`Exito: ${respuesta.message}`);
                    //vamos a limpiar datos
                }
                else{
                    toast.error(`Error: ${respuesta.message}`);
                    return false;
                }
            }
            catch(error){
                console.error('Error al entregar trabajo:', error);
                toast.error("Error, " + error);
                return false;
            }
        });
    }

    //entrega parcial de trabajo
    const entregaParcialTrabajoTutor = async(formData,codigo,nombreEmpresa,idEntrega) =>{
        return withLoading(async () =>{
            try{
                console.log("el data es",formData);

                if (!formData.trabajos || (Array.isArray(formData.trabajos) && formData.trabajos.length === 0)) {
                    toast.error("Debes subir al menos un archivo para entregar el trabajo");
                    return; 
                }

                //subir trabajo entrega parcial
                const respuesta = await contabilidadApi.entregaTrabajoParcial(formData,codigo,nombreEmpresa,idEntrega);

                console.log("la respuesta es ",respuesta);
                if(respuesta.success){
                    toast.success(`Exito: ${respuesta.message}`);
                    //vamos a limpiar datos
                }
                else{
                    toast.error(`Error: ${respuesta.message}`);
                    return false;
                }
            }
            catch(error){
                console.error('Error al entregar trabajo parcial:', error);
                toast.error("Error, " + error);
                return false;
            }
        },'Cargando entreg de trabajo');
    }

    //add servicio
    const addServicio = async(servicioData, updateCliente, nombreEmpresa,actualizarClienteApi) => {         
        console.log("add servicio", updateCliente);                  
        
        return withLoading(async () => {             
            try{                  
                //formatear numeros                 
                const servicio_obj = new ServicioAgendado(servicioData);                 
                const servicioDataMap = servicio_obj.toMap();                  
                
                //cliente                 
                const cliente_obj = new Cliente(updateCliente);                 
                const clienteUpdateMap = cliente_obj.toActualizarRapido();                  
                
                // ✅ AGREGAR AWAIT AQUÍ
                
                const respuesta = await contabilidadApi.addServicio(servicioDataMap, clienteUpdateMap, nombreEmpresa , actualizarClienteApi);                  
        
                // ✅ Validar que la respuesta tenga la estructura esperada
                if (!respuesta || typeof respuesta.success !== 'boolean') {
                    throw new Error('Respuesta del servidor inválida');
                }
                
                console.log("tenemos respuesta",respuesta);
                const dataServicio = respuesta.servicio;
                console.log("datos servicio",dataServicio);

                if (respuesta.success) {
                    // ✅ Solo procesar si hay datos del servicio
                    const servicioDataJson = ServicioAgendado.fromJson(dataServicio);
                    console.log("La respuesta convertida:", servicioDataJson);
                    
                    toast.success(`Éxito: ${respuesta.message}`);
                    return servicioDataJson;

                } else {
                    // ❌ En caso de error, NO retornar datos
                    toast.error(`Error: ${respuesta.message}`);
                    throw new Error(respuesta.message || 'Error desconocido');
                }
                                    
            }             
            catch(error){                 
                console.error('Error al subir servicio:', error);
                // Mejorar manejo de errores
                const errorMessage = error.response?.data?.error || error.message || 'Error desconocido';
                toast.error("Error: " + errorMessage);                 
                return null;             
            }          
        }, 'Subiendo servicio'); 
        
    }   

    //obtener servicio por cliente
    const getServiciosPorCliente = async(nombreEmpresa,numeroCliente) =>{
        try{
            setLoading(true);
            const data = await contabilidadApi.obtenerServiciosCliente(nombreEmpresa,numeroCliente);
            console.log("obtenido servicios de cliente",data);
            const dataConvertida = Object.values(data);
            const serviciosObj = dataConvertida.map(item => ServicioAgendado.fromJson(item));
            setServiciosCliente(serviciosObj);
            return serviciosObj;
        }
        catch(error){
            console.error("Error al obtener servicio:", error);
            setError(error.message || "Error al cargar la solicitud");
            return null;
        }
        finally{
            setLoading(false);
        }
    }

    //obtener link de archivos
    const searchArchivoDrive = async(nombreEmpresa,nombreArchivo) =>{
        console.log("buscando archivo por el searc",nombreEmpresa,nombreArchivo);
        try{
            const respuesta = await contabilidadApi.searchPagoDrive(nombreEmpresa,nombreArchivo);

            if(respuesta.success){
                return respuesta.data
            }
        }
        catch(error){
            return null;
        }
    }

    //busqueda de servicios
    const getBusquedaServicios = async(nombreEmpresa, busqueda = '') =>{
        try{
            setLoading(true);
            setError(null);
            const respuesta = await contabilidadApi.searchServicios(nombreEmpresa, busqueda);

            if (respuesta.success) {
                
                const dataConvertida = Object.values(respuesta.data);
                const servicios_obj = dataConvertida.map(item => ServicioAgendado.fromJson(item));
                setserviciosBusqueda(servicios_obj);
                
                return respuesta.data;
            } else {
                throw new Error(respuesta.error || 'Error desconocido');
            }

        }
        catch(error){
            console.error('❌ Error al cargar servicios:', error);
            setError(error.message);
            setserviciosBusqueda([]); // ✅ Limpiar en caso de error
            throw error;
        }finally{
            setLoading(false);
        }

    };
    const busquedaServiciosOptions = useMemo(() =>{
        if (!serviciosBusqueda || serviciosBusqueda.length === 0) {
        return [];
      }

      return serviciosBusqueda.map(servicio => ({
        value: servicio.codigo,
        label: `${servicio.codigo}`,
      }));

    }, [serviciosBusqueda]);
    const handleBusquedaServicios = (inputValue) =>{
        if(inputValue.length >=2){
            const nombreEmpresa = 'DUFY%20ASESORIAS'; //ajustar nombre de empresa
            getBusquedaServicios(nombreEmpresa, inputValue);
        }
    }

    //obtener estadisticas de tutor
    const getEstadisticasTutor = async(nombreTutor) =>{
        try{
            setloadingEstadisticas(true);
            const data = await contabilidadApi.estadisticasPagosTutor(configuracion.nombreEmpresa,nombreTutor);
            console.log("data",data);
            setEstadisticas(data.data);
            seterrorEstasdisticas(null);
            return data;
        }
        catch(error){
            console.error("Error al obtener servicios:", error);
            seterrorEstasdisticas(error.message || "Error al cargar los servicios");
            return null;
        }
        finally{
            setloadingEstadisticas(false);
        }
    }

    //obtener pagos por referencia
    const getPagosPorReferencia = async(fechaBusqueda, nombreEmpresa , referencia) =>{
        console.log("tenemos de fecha",fechaBusqueda,referencia,nombreEmpresa);
        try{
            const fecha = new Date(fechaBusqueda.getFullYear(),fechaBusqueda.getMonth(),fechaBusqueda.getDate());
            
            const fechaConverted = toYYYYMMDD(fecha);

            const respuesta = await contabilidadApi.getPagosReferencias(fechaConverted,nombreEmpresa, referencia);

            if (respuesta && respuesta.success) {
                const dataBackend = respuesta.data.data;

                const totalPagos = dataBackend.totalPagos || 0;
                const listaCruda = dataBackend.pagosDetallados || [];

                const listaProcesada = listaCruda.map(pagoJson => {
                    return RegistrarPagos.fromJson(pagoJson);
                });


                return {
                    pagosDetallados: listaProcesada,
                    totalPagos: totalPagos
                };

            }

            return null;

        }
        catch(error){
            console.error('Error interno:', error);
            return null;
        }
    }

    //sockets de servicios
    const setupWebSocketsServicios = (servicioObjeto ,nombreEmpresa, numeroCliente = 0) =>{
        console.log("cargano socket de servicios",servicioObjeto,nombreEmpresa);
        const socket = getSocket()

        //actualizar servicio
        const handleServicioUpdate = async (id,originalId) => {
            console.log(`Recibida actualización de el servicio ${id} - ${originalId}`);

            const data = await contabilidadApi.obtenerServicioPorId(servicioObjeto.codigo, nombreEmpresa);
            console.log("tenemos data",data);
            console.log("servicio obj",servicioObjeto);

            if (data.codigo === servicioObjeto.codigo) {
                const servicioActualizado = ServicioAgendado.fromJson(data);

                setServicio(servicioActualizado);

                //actualziamos de la busqueda tambien
                setserviciosBusqueda(prevBusqueda => {
                    console.log(`Actualizando lista de búsqueda para el servicio: ${servicioActualizado.codigo}`);
                    // Usamos .map() para crear un nuevo array con el item actualizado
                    return prevBusqueda.map(servicioEnLista => 
                        servicioEnLista.codigo === servicioActualizado.codigo 
                            ? servicioActualizado 
                            : servicioEnLista     
                    );
                });

            }


        };

        //actualizar servicios del cliente
        const handleServiciosClienteUpdate = (id,originalId,data,type,sourc,nombreEmpresa,servicioData) => {
            

        };

        if (servicioObjeto !== null){

            socket.emit('join-servicio', {idServicio: servicioObjeto.codigo , nombreEmpresa: nombreEmpresa});

            //regisdtrar listener de cliente id
            socket.on('servicio:id', handleServicioUpdate);
        
        }

        console.log("web socket",numeroCliente);
        if(numeroCliente != 0){
            console.log("coenctado numero del cliente")

            socket.emit('join-serviciosclientes-room', numeroCliente);

            socket.on('servicios:cliente', ({id,originalId,data,type,sourc,nombreEmpresa,servicioData}) =>{
                console.log("obteniendo servicios del cliente",servicioData);
                handleServiciosClienteUpdate(id,originalId,data,type,sourc,nombreEmpresa,servicioData);
            });

        }

        return () =>{
            socket.emit('leave-serviciosclientes-room',{idServicio: servicioObjeto.codigo , nombreEmpresa: nombreEmpresa})
            socket.off('servicio:id',handleServicioUpdate)
            socket.off('join-serviciosclientes-room',numeroCliente);
        }


    }

    return{
        servicio,
        servicios,

        //actualizar servicio 
        updateServicio,
        addPago,
        deletePago, // eliminar pago
        searchArchivoDrive, //busqueda de archivos
        addEntregaParcial,
        deleteEntregaParcial,

        //busqueda de servicios
        busquedaServiciosOptions,
        getBusquedaServicios,
        serviciosBusqueda,
        handleBusquedaServicios,

        //servicios clientes
        serviciosPorClientes,
        getServiciosPorCliente,

        loadingServicios,
        errorServicios,

        cargarServicios,
        cargarServicioPorCodigo,
        entregarTrabajoTutor,
        entregaParcialTrabajoTutor,
        addServicio,

        //sockets
        setupWebSocketsServicios,

        //estadisticas tutor
        getEstadisticasTutor,
        loadingEstadisticas,
        errorEstasdisticas,
        estadisticas,

        getPagosPorReferencia,
    }

} 